export class HubStreamResponseError extends Error {
  readonly status: number;

  constructor(streamName: string, status: number) {
    super(`${streamName} failed (${status}).`);
    this.name = "HubStreamResponseError";
    this.status = status;
  }
}

export function isHubStreamAuthError(error: unknown): boolean {
  return (
    error instanceof HubStreamResponseError &&
    (error.status === 401 || error.status === 403)
  );
}

export function isHubStreamPresenceRowMissing(error: unknown): boolean {
  return error instanceof HubStreamResponseError && error.status === 409;
}

export function isHubStreamTerminalError(error: unknown): boolean {
  if (!(error instanceof HubStreamResponseError)) {
    return false;
  }
  return (
    error.status >= 400 &&
    error.status < 500 &&
    error.status !== 408 &&
    error.status !== 409 &&
    error.status !== 425 &&
    error.status !== 429 &&
    error.status !== 502 &&
    error.status !== 503 &&
    error.status !== 504
  );
}
